/**
 * Copyright (C) Siemens AG 1996-2025 ALL RIGHTS RESERVED.
 */

import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';
import {BaseFormFieldDirective} from '../../base-form-field.directive';
import {FieldLabelComponent} from '../field-label/field-label.component';
import {IxModule} from '@siemens/ix-angular';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-email-input',
  imports: [
    CommonModule,
    FieldLabelComponent,
    IxModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  templateUrl: './email-input.component.html',
  styleUrl: '../input-components.scss',
})
export class EmailInputComponent extends BaseFormFieldDirective {
  constructor() {
    super();
  }
}
